import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CButtonGroup,
  CCol,
  CFormCheck,
  CModal,
  CModalBody,
  CModalFooter,
  CRow,
} from '@coreui/react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'

const BobbingCardsModal = ({ componentData, modifyData, modalSpecificData, onCancel }) => {
  const { isEdit, type, cardIndex } = modalSpecificData

  const { userSessionObj } = useContext(GlobalContext)
  const [title, setTitle] = useState('')
  const [isHeadingUp, setIsHeadingUp] = useState(false)
  const [heading, setHeading] = useState('')
  const [imageS3key, setImageS3key] = useState('')
  const [link, setLink] = useState({ type: '', data: {} })
  const [errorData, setErrorData] = useState({})
  const [upImageData, setUpImageData] = useState([])
  const [downImageData, setDownImageData] = useState([])
  const { loader, setLoader } = useContext(AppContext)

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    const upImg = [
      {
        title: '',
        id: 'upImg',
        width: 305,
        height: 172,
        divheight: '8rem',
        divwidth: '13.125rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '6px',
        imagePaddingY: '6px',
      },
    ]
    const downImg = [
      {
        title: '',
        id: 'downImg',
        width: 305,
        height: 172,
        divheight: '8rem',
        divwidth: '13.125rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '7px',
        imagePaddingY: '7px',
      },
    ]

    if (isEdit) {
      if (type === 'HEADING') {
        setTitle(componentData?.data?.title)
        return
      }
      let tempdata = componentData.data?.card_data

      setIsHeadingUp(tempdata[cardIndex].is_heading_up)
      setHeading(tempdata[cardIndex].heading)
      setImageS3key(tempdata[cardIndex].image_s3key)
      setLink(tempdata[cardIndex].link)

      if (tempdata[cardIndex].is_heading_up) {
        upImg[0]['assetId'] = tempdata[cardIndex].image_s3key
        upImg[0]['imageUrl'] = getThumbnail(
          userSessionObj.session_data.cf_domain_name,
          tempdata[cardIndex].image_s3key,
        )
      }
      if (!tempdata[cardIndex].is_heading_up) {
        downImg[0]['assetId'] = tempdata[cardIndex].image_s3key
        downImg[0]['imageUrl'] = getThumbnail(
          userSessionObj.session_data.cf_domain_name,
          tempdata[cardIndex].image_s3key,
        )
      }
    }
    setUpImageData(upImg)
    setDownImageData(downImg)
  }, [])

  const onCardTypeChange = (event) => {
    const { value } = event.target
    setImageS3key('')

    const upImg = [
      {
        title: '',
        id: 'upImg',
        width: 305,
        height: 172,
        divheight: '8rem',
        divwidth: '13.125rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '6px',
        imagePaddingY: '6px',
      },
    ]
    const downImg = [
      {
        title: '',
        id: 'downImg',
        width: 305,
        height: 172,
        divheight: '8rem',
        divwidth: '13.125rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '7px',
        imagePaddingY: '7px',
      },
    ]

    setUpImageData(upImg)
    setDownImageData(downImg)
    setIsHeadingUp(value === 'up' ? true : false)
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (heading.trim().length === 0 && type === 'CARD') {
      isFormValid = false
      temp.heading = 'Heading cannot be Empty!'
    }
    if (imageS3key.trim().length === 0 && type === 'CARD') {
      isFormValid = false
      temp.imageS3key = 'Upload Image!'
    }

    if (link.type && !validateLink(link).isValid) {
      isFormValid = false
      temp.link = validateLink(link).error
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const handleSave = () => {
    if (!validateInfo()) return
    let tempdata = componentData.data
    if (type === 'CARD') {
      let elementObj = {
        image_s3key: imageS3key,
        heading: heading,
        is_heading_up: isHeadingUp,
        link: link,
      }

      if (!isEdit) {
        tempdata?.card_data.splice(cardIndex + 1, 0, elementObj)
      } else {
        tempdata?.card_data.splice(cardIndex, 1, elementObj)
      }

      modifyData(componentData.id, tempdata)
      return
    }

    tempdata['title'] = title

    modifyData(componentData.id, tempdata)
  }
  return (
    <CModal size="lg" className="recent-stories-modal" visible={true}>
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      {type === 'CARD' ? (
        <CModalBody style={{ height: '70vh' }} className="px-5 font-13px">
          <div style={{ fontSize: '1.3rem' }} className="d-flex justify-content-center">
            <p>
              <b style={{ fontWeight: '500' }}>Card Editor</b>
            </p>
          </div>

          <CRow className="my-3">
            <CCol>
              <h6 className="font-13px">
                Select the Card Type <span style={{ color: 'red' }}>*</span>
              </h6>

              <CRow className="mt-4">
                <CButtonGroup
                  id="group1"
                  role="group"
                  aria-label="Basic checkbox toggle button group"
                  style={{ fontSize: '12px' }}
                  className=" justify-content-between"
                >
                  <div className="d-flex flex-column">
                    <CFormCheck
                      type="radio"
                      id="isHeadingDown"
                      label="Heading is below the Image"
                      value={'down'}
                      checked={!isHeadingUp}
                      onChange={(e) => onCardTypeChange(e)}
                    />

                    {downImageData && (
                      <ImageUploader data={downImageData} isDisabled={isHeadingUp} />
                    )}

                    <div
                      style={{
                        width: '13.125rem',
                        background: '#dfdfdf',
                        border: `1px solid ${!isHeadingUp ? ' #2172eb' : '#707070'}`,
                        borderRadius: '2px',
                        color: '#6b6b6b',
                      }}
                      className=" py-1 px-2 mt-2"
                    >
                      Heading
                    </div>
                    <span
                      className="text-center mt-1"
                      style={{ fontSize: '10px', color: '#707070' }}
                    >
                      Image Dimention: 305px X 172px
                    </span>
                  </div>
                  <div className="d-flex flex-column">
                    <CFormCheck
                      type="radio"
                      id="isHeadingUp"
                      label="Heading is above the Image"
                      value={'up'}
                      checked={isHeadingUp}
                      onChange={(e) => onCardTypeChange(e)}
                    />
                    <div
                      style={{
                        width: '13.125rem',
                        background: '#dfdfdf',
                        border: `1px solid ${isHeadingUp ? ' #2172eb' : '#707070'}`,
                        borderRadius: '2px',
                        color: '#6b6b6b',
                      }}
                      className=" py-1 px-2 mb-2"
                    >
                      Heading
                    </div>
                    {upImageData && <ImageUploader data={upImageData} isDisabled={!isHeadingUp} />}
                    <span
                      className="text-center mt-1"
                      style={{ fontSize: '10px', color: '#707070' }}
                    >
                      Image Dimention: 305px X 172px
                    </span>
                  </div>
                </CButtonGroup>
              </CRow>
              <div className="message-text error-message">
                <p>{errorData.imageS3key}</p>
              </div>
            </CCol>
          </CRow>
          <CRow className="my-3 mt-4">
            <CCol>
              <h6 className="font-13px">
                Heading <span style={{ color: 'red' }}>*</span>
              </h6>
              <CustomDescriptionBox
                limit={26}
                rows={1}
                value={heading}
                onChange={setHeading}
                isMandatory={true}
                errorText={errorData?.heading}
                useFormInput={true}
                style={{ fontSize: '13px' }}
              />
            </CCol>
          </CRow>

          <AttachLink
            categoryData={
              categoryList
                ? categoryList?.data.filter((info, idx) => info.type === 'category' && info.status)
                : []
            }
            linkData={link}
            setLinkData={(value) => {
              clearError('link')
              setLink(value)
            }}
          />
          <div className="message-text error-message">
            <p>{errorData.link}</p>
          </div>
        </CModalBody>
      ) : (
        <CModalBody className="px-5">
          <div style={{ fontSize: '1.3rem' }} className="d-flex justify-content-center">
            <p>
              <b style={{ fontWeight: '500' }}>Text Editor</b>
            </p>
          </div>
          <CRow className="my-3 mt-5">
            <CCol>
              <h6 className="font-13px">Section Title</h6>
              <CustomDescriptionBox
                limit={35}
                rows={1}
                value={title}
                onChange={setTitle}
                style={{ fontSize: '13px' }}
                useFormInput={true}
              />
            </CCol>
          </CRow>
        </CModalBody>
      )}
      <CModalFooter style={{ borderTop: 0 }} className="px-5">
        <div className="pb-2">
          <CButton
            style={{ color: 'black', border: '1px solid black', fontSize: '1.1rem' }}
            className="mx-4 bg-white rounded-1 btn-focus-none"
            onClick={onCancel}
          >
            Cancel
          </CButton>
          <CButton
            style={{ fontSize: '1.1rem' }}
            className=" bg-black rounded-1 btn-focus-none px-3"
            onClick={handleSave}
          >
            Save
          </CButton>
        </div>
      </CModalFooter>
    </CModal>
  )
}

export default BobbingCardsModal
